module.exports = __webpack_public_path__ + "img/frame (241).4bcf4698.jpg";